import { render, staticRenderFns } from "./EmailDeliveryView.vue?vue&type=template&id=5a627f91"
import script from "./EmailDeliveryView.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports